var $f69e7a23857afc72$exports = {};
$f69e7a23857afc72$exports = {
    "loading": `Chargement...`,
    "placeholder": `S\xe9lectionner\u{2026}`
};


export {$f69e7a23857afc72$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
